import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@context/AuthContext';
import { PlanificacionProvider } from '@context/PlanificacionContext';
import { router } from './router';

function App() {
  return (
    <AuthProvider>
      <PlanificacionProvider>
        <RouterProvider router={router} />
      </PlanificacionProvider>
    </AuthProvider>
  );
}

export default App;
